import React, { memo, useMemo } from 'react';
import { ChartRenderer } from './ChartRenderer.js';
import { useChartData } from '../hooks/useChartData.js';

export const MemoizedChartRenderer = memo(({ 
  metric, 
  filteredData, 
  climbingStyle,
  gradeSystem,
  onGradeClick,
  isHorizontal,
  onLayoutChange,
  showDistinctRoutes,
  selectedStat  // Add new prop
}) => {
  const chartData = useChartData(filteredData, metric, climbingStyle);
  
  const chartComponent = useMemo(() => (
    <ChartRenderer
      selectedMetric={metric}
      chartData={chartData}
      filteredData={filteredData}
      climbingStyle={climbingStyle}
      gradeSystem={gradeSystem}
      onGradeClick={onGradeClick}
      isHorizontal={isHorizontal}
      onLayoutChange={onLayoutChange}
      showDistinctRoutes={showDistinctRoutes}
      selectedStat={selectedStat}  // Pass through
    />
  ), [
    metric,
    chartData,
    filteredData,
    climbingStyle,
    gradeSystem,
    onGradeClick,
    isHorizontal,
    onLayoutChange,
    showDistinctRoutes,
    selectedStat  // Add to dependencies
  ]);

  return chartComponent;
}, (prevProps, nextProps) => {
  return (
    prevProps.metric === nextProps.metric &&
    prevProps.filteredData === nextProps.filteredData &&
    prevProps.climbingStyle === nextProps.climbingStyle &&
    prevProps.gradeSystem === nextProps.gradeSystem &&
    prevProps.isHorizontal === nextProps.isHorizontal &&
    prevProps.showDistinctRoutes === nextProps.showDistinctRoutes &&
    prevProps.selectedStat === nextProps.selectedStat  // Add to comparison
  );
});

MemoizedChartRenderer.displayName = 'MemoizedChartRenderer';